import { AddExternalSupplierPanel } from "@/components/organisms";

export const AddExternalSupplier = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <AddExternalSupplierPanel />
    </div>
  );
};